<script setup lang="ts">
import { ref } from 'vue'
import { MarButton, MarTextInput } from '@nimling/components-nimtech'

const { error = '' } = defineProps<{ error?: string }>()
const emit = defineEmits<{ submit: [key: string] }>()

const key = ref('')

const submit = () => {
  if (key.value.trim()) emit('submit', key.value)
}
</script>

<template>
  <div class="sign-in">
    <form class="sign-in-card glass-raised" @submit.prevent="submit">
      <div class="sign-in-brand">
        <img class="sidebar-brand-icon" src="/connect.svg" alt="" style="inline-size: 1.75em; block-size: 1.75em" />
        <strong>connect</strong>
      </div>
      <p class="muted">
        This install runs on its own. Sign in with an admin api key, <span class="mono">sk-con-...</span>, or the
        <span class="mono">CONNECT_ADMIN_KEY</span> it was started with.
      </p>
      <MarTextInput v-model="key" label="API key" placeholder="sk-con-..." fluid />
      <span v-if="error" class="sign-in-error">{{ error }}</span>
      <MarButton label="Sign in" severity="primary" type="submit" />
    </form>
  </div>
</template>

<style scoped>
.sign-in {
  position: absolute;
  inset: 0;
  display: grid;
  place-items: center;
  padding: 1rem;
}

.sign-in-card {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: min(26rem, 100%);
  padding: 1.75rem;
  border-radius: var(--mar-content-border-radius);
}

.sign-in-brand {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  font-size: 1.1rem;
}

.sign-in-error {
  color: var(--mar-danger-color, var(--mar-text-color));
  font-size: 0.8rem;
}
</style>
